<template>
    <Field
        v-slot="{ field, errors }"
        v-model="model[name]"
        :name="name"
        :label="title"
        :rules="rules"
        as="div"
        mode="eager"
        :disabled="validationDisabled">
        <div class="text-para-s font-semibold">
            <span class="whitespace-nowrap">
                <span class="whitespace-normal">{{ title }}</span>
                <span v-if="required" aria-hidden="true"> *</span>
            </span>
            <span v-if="suffix" class="text-black-500 font-normal"> {{ suffix }}</span>
        </div>
        <Dropdown
            :id="name"
            v-bind="field"
            v-model="model[name]"
            :name="name"
            :title="placeholder"
            :value="defaultValue"
            :required="required"
            :error="errors.length > 0"
            :described-by="errors.length > 0 ? `${name}-error` : ''"
            :white="true"
            :searchable="searchable"
            class="w-full min-w-40">
            <DropdownItem v-for="(label, iValue, index) in options" :key="index" :value="iValue" :label="label" />
        </Dropdown>
        <span v-if="errors.length > 0" :id="`${name}-error`" class="text-error text-para-xs mt-1 md:mt-2">
            {{ errors[0] }}
        </span>
    </Field>
</template>

<script lang="ts">
import { PropType } from 'vue';
import Dropdown from '../../base/Dropdown.vue';
import DropdownItem from '../../base/DropdownItem.vue';
import { Field } from 'vee-validate';

export default {
    components: { Field, DropdownItem, Dropdown },
    inject: ['model', 'currentStep'],
    props: {
        name: { type: String, required: true },
        title: { type: String, required: true },
        suffix: { type: String },
        placeholder: { type: String, default: '' },
        defaultValue: { type: String },
        required: { type: Boolean, default: false },
        searchable: { type: Boolean, default: false },
        labels: { type: Array as PropType<Array<string>>, default: () => [] },
        stepIndex: { type: Number, required: true },
    },
    computed: {
        validationDisabled(): boolean {
            return this.currentStep !== this.stepIndex;
        },
        options(): Record<string, string> {
            const result = {};
            if (this.labels) {
                this.labels.forEach(s => {
                    const keyValue = s.split(':');
                    if (keyValue.length === 2) {
                        result[keyValue[1]] = keyValue[0];
                    }
                });
            }
            return result;
        },
        rules(): Record<string, unknown> {
            /* eslint-disable */
            return {
                required: this.required,
            };
            /* eslint-enable */
        },
    },
    created(): void {
        if (!this.model[this.name] && this.defaultValue) {
            this.model[this.name] = this.defaultValue;
        }
    },
};
</script>
